<template>
  <div id="app">
    <CollaborativeEditing msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import CollaborativeEditing from './components/CollaborativeEditing'

export default {
  name: 'App',
  components: {
    CollaborativeEditing
  }
}
</script>

<style lang="scss">
*,
*::before,
*::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  line-height: 1.7;
  font-feature-settings: "cv05" 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>